// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__1lHVk","modalFooterButton":"ModalNotes_modalFooterButton__1bPWb"};